import { useEffect, useCallback } from "react";
import { selectLabel } from "redux/points/actions";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentShapes } from "redux/shape/selector";
import { updateShapeLabel } from "redux/shape/actions";
import { selectIsUserTypingStatus } from "redux/keyboard/selectors";
import { selectIsOpenStatus } from "redux/app/selectors";
import {
  normalizeKeys,
  eventToKeys,
  formatShortcut,
} from "components/LabelPicker/shortcutKeys";

export function useShortcutKeyBoard(listLabel) {
  const dispatch = useDispatch();
  const currentShape = useSelector(getCurrentShapes);
  const isUserTyping = useSelector(selectIsUserTypingStatus);
  const isOpenStatus = useSelector(selectIsOpenStatus);
  const normalizeKeyCombo = useCallback((e) => {
    if (e.key === "Escape" || e.key === "Tab") return;
    e.preventDefault();
    const keys = eventToKeys(e);
    return formatShortcut(normalizeKeys(keys));
  }, []);

  const handleKeyDown = useCallback(
    (e) => {
      if (isUserTyping || isOpenStatus) return;
      e.preventDefault();
      const combo = normalizeKeyCombo(e);
      const found = listLabel.find(
        (s) => formatShortcut(normalizeKeys(s.shortcutKeyArray)) === combo
      );
      if (found) {
        dispatch(selectLabel(found));
        if (currentShape)
          dispatch(
            updateShapeLabel({
              payload: {
                id: currentShape.id,
                labelId: found.key,
                color: found.color,
              },
            })
          );
      }
    },
    [listLabel, normalizeKeyCombo]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);
}
